import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { validations, validateCase as vCase } from 'core/validate'
import { CreateBankGuaranteeContainer } from './styled'
import { bgVendorCreatePath } from 'routes'
import { getRefBankGuaranteeOptions, loadBankGuaranteeForExtend } from 'ducks/bankGuarantee'
import { getVendors, getCompanies } from 'ducks/options'
import { isNullOrEmpty } from 'core/utilities'
import r from 'reactotron-react-js'

const CreateBankGuaranteeModal = (props) => {
  const { valueForm, change, handleSubmit, closeForm, history, vendorOptions, companyOptions, bgRefOptions } = props
  const { vendorCode, companyCode } = valueForm

  useEffect(() => {
    if (!vendorOptions.data.length && !vendorOptions.loading) {
      props.getVendors()
    }

    if (!companyOptions.data.length && !companyOptions.loading) {
      props.getCompanies()
    }

    if (!bgRefOptions.data.length && !bgRefOptions.loading) {
      props.getRefBankGuaranteeOptions()
    }
  }, [])
  
  const vendorCodeInBG = bgRefOptions.data.map(data => data.vendorCode) || []
  const vendorOpt = vendorOptions.data.filter(x => vendorCodeInBG.includes(x.value))
  const companyCodeInBG = bgRefOptions.data.map(data => data.companyCode) || []
  const companyOpt = companyOptions.data.filter(x => companyCodeInBG.includes(x.value))

  const bgOption = () => {
    var result = bgRefOptions.data

    if (!isNullOrEmpty(companyCode)) {
      result = result.filter(x => x.companyCode === companyCode)
    }

    if (!isNullOrEmpty(vendorCode)) {
      result = result.filter(x => x.vendorCode === vendorCode)
    }

    return result
  }

  const vendorOptByCompanyCode = () => {
    const bgRefByCompanyCode = bgRefOptions.data.filter(x => x.companyCode === companyCode) || []
    const vendorCodeInBG = bgRefByCompanyCode.map(data => data.vendorCode) || []

    return vendorCodeInBG.length > 0 ? vendorOpt.filter(x => vendorCodeInBG.includes(x.value)) : vendorOpt
  }

  const submitCreateForm = () => {
    if (valueForm.createType === 'original') {
      if ((valueForm.BG01 || []).length === 0) {
        throw new SubmissionError({ BG01: 'Require!' })
      } else {
        closeForm()
        history.push(bgVendorCreatePath(valueForm.createType))
      }
    } else if (valueForm.createType === 'extend') {
      var errors = {}

      validations(valueForm, 'vendorCode', [vCase.require], errors)
      validations(valueForm, 'companyCode', [vCase.require], errors)
      validations(valueForm, 'referenceBankGuaranteeNumber', [vCase.require], errors)
      if ((valueForm.BG01 || []).length === 0) {
        errors.BG01 = 'Require!'
      }

      if (Object.keys(errors).length) {
        throw new SubmissionError(errors)
      } else {
        props.loadBankGuaranteeForExtend(valueForm.referenceBankGuaranteeId, (data) => {
          change('typeOfBond', data.typeOfBond)
          change('otherTypeOfBond', data.otherTypeOfBond)
          change('amount', data.amount)
          change('bankOwner', data.bankOwner)
          change('vendorContacts', data.vendorContacts)
          change('projectManagerUser', data.projectManagerUser)
          change('job', data.job)
          closeForm()
          history.push(bgVendorCreatePath(valueForm.createType))
        })
      }
    }
  }

  return (
    <Dialog className='dialog-full-height' open={true} maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Bank Guarantee</DialogTitle>
      <DialogContent>
        <form>
          <CreateBankGuaranteeContainer>
            <div className='rowFields'>
              <Field 
                name='createType' 
                label='' 
                type={type.radio}
                options={[
                  { value: 'original', text: 'Original' },
                  { value: 'extend', text: 'Extend' }
                ]} 
                fieldInputStyle={{ justifyContent: 'space-around' }}
                horizontalView
                component={FieldInput} />
            </div>
            {
              valueForm.createType === 'extend' ? 
                <React.Fragment>
                  <div className='rowFields'>
                    <Field 
                      name='companyCode' 
                      label='Company' 
                      require
                      ignoreClearValue={false}
                      type={type.select}
                      options={companyOpt}
                      loading={companyOptions.loading}
                      component={FieldInput} />
                  </div>
                  <div className='rowFields'>
                    <Field 
                      name='vendorCode' 
                      label='Vendor' 
                      require
                      ignoreClearValue={false}
                      type={type.select}
                      options={isNullOrEmpty(companyCode) ? vendorOpt : vendorOptByCompanyCode()}
                      loading={vendorOptions.loading}
                      component={FieldInput} />
                  </div>
                  <div className='rowFields'>
                    <Field 
                      name='referenceBankGuaranteeNumber' 
                      label='Bank Guarantee for Extend' 
                      require
                      ignoreClearValue={false}
                      type={type.select}
                      options={bgOption()}
                      loading={bgRefOptions.loading}
                      specialOnChange={(value) => {
                        var bgRef = bgRefOptions.data.find(x => x.value === value)
                        if (bgRef) {
                          change('referenceBankGuaranteeId', bgRef.id)
                          if (isNullOrEmpty(companyCode)) {
                            change('companyCode', bgRef.companyCode)
                          }
                          if (isNullOrEmpty(vendorCode)) {
                            change('vendorCode', bgRef.vendorCode)
                          }
                        }
                      }}
                      component={FieldInput} />
                  </div>
                </React.Fragment> : null
            }
            <div className='rowFields'>
              <Field 
                name='BG01' 
                label='Attachment bank guarantee' 
                require 
                replaceUpload
                clearFiles={() => { }}
                type={type.file}
                containerStyle={{ width: '100%' }}
                component={FieldInput} />
            </div>
          </CreateBankGuaranteeContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitCreateForm())}>
          <Button
            color='red'
            content='Cancel'
            type='button'
            onClick={() => closeForm()}
          />
          <Button
            color='blue'
            content='Create'
            type='submit'
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const vf = getFormValues('formBankGuarantee')(state) || {}
  return ({
    valueForm: vf,
    initialValues: {
      ...vf,
      createType: vf.createType || 'original',
      location: 'dtgo'
    },
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies,
    bgRefOptions: state.bg.bgRefOptions
  })
}
  
const mapDispatchToProps = {
  getVendors, 
  getCompanies,
  getRefBankGuaranteeOptions,
  loadBankGuaranteeForExtend
}

const CreateBankGuaranteeModalForm = reduxForm({
  form: 'formBankGuarantee',
  enableReinitialize: true,
  destroyOnUnmount : false
})(CreateBankGuaranteeModal)

export default connect(mapStateToProps, mapDispatchToProps)(CreateBankGuaranteeModalForm)
